import React from 'react'
import PropTypes from 'prop-types'

import Pressable from 'src/ui/Pressable/Pressable'

import HeroCardReferenceSkeleton from './HeroCardReferenceSkeleton'

const HeroCardReference = ({ title, subtitle, linkUrl }) => {
  const disabled = !linkUrl
  return (
    <Pressable linkUrl={linkUrl} disabled={disabled}>
      <HeroCardReferenceSkeleton
        disabled={disabled}
        titleSection={title}
        subtitleSection={subtitle}
      />
    </Pressable>
  )
}

HeroCardReference.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  linkUrl: PropTypes.string,
}

export default HeroCardReference
